<template>
  <div class="library-page">
    <!-- 顶部导航 -->
    <!-- <AppHeader /> -->

     <!-- 1. Banner 区域 (深色) -->
    <section class="lib-banner">
      <div class="banner-overlay"></div>
      <div class="container">
        <div class="banner-content">
          <h1>AI数字人<br>语音交互系统</h1>
          <p class="subtitle">校园智能新体验，让师生生活更美好</p>
          <button class="btn-primary" @click="contactUs">
            合作咨询 <span class="divider">|</span> 020-82038386
          </button>
        </div>
        <!-- 移除右侧模拟设备，让背景图片中的设备透出来 -->
      </div>
    </section>

    <!-- 2. 核心功能 (白色背景) -->
     <!-- 2. 核心功能 (白色背景) -->
    <section class="lib-features">
  <div class="container">
    <div class="section-title">
      <h2>核心功能</h2>
      <p class="subtitle">以AI赋能校园服务，让沟通更自然，让服务更智能</p>
    </div>
    <div class="features-grid">
      <div class="feature-card" v-for="item in features" :key="item.id">
        <h4>{{ item.title }}</h4>
        <p>{{ item.desc }}</p>
        <div class="icon-box">
          <!-- 假设您的图片资源是蓝色的，如果不是，可以通过CSS filter调整颜色 -->
          <img src="../assets/images/headphone-icon.png" alt="图标" class="feature-icon">
        </div>
      </div>
    </div>
  </div>
</section>

    <!-- 3. 软硬件一体化终端 (浅灰背景) -->
   <section class="lib-terminal">
  <div class="container">
    <div class="section-title">
      <h2>软硬件一体化智能终端</h2>
      <p class="subtitle">集成高性能计算、语音交互、高清显示能力</p>
    </div>
    <div class="terminal-layout">
      <div class="terminal-features">
        <div class="tf-item" v-for="(item, index) in terminalFeatures" :key="index">
          <div class="check-icon">
            <!-- 建议替换为蓝色的勾选图标 -->
            <img src="../assets/images/check-icon.png" alt="勾选" class="check-img">
          </div>
          <div class="tf-content">
            <!-- 图片中只有一行加粗文字，直接使用 strong 或调整样式 -->
            <span class="feature-text">{{ item.text }}</span>
          </div>
        </div>
      </div>
      <div class="terminal-device">
        <div class="image-wrapper">
          <img src="../assets/images/class-card-device.png" alt="智能终端设备" class="device-img">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- 4. 产品优势 (极淡背景) -->
<section class="lib-advantages">
  <div class="container">
    <div class="section-title">
      <h2>产品优势</h2>
      <p class="subtitle">专业的技术与服务团队，保障系统稳定运行</p>
    </div>
    <div class="adv-grid">
      <div class="adv-item" v-for="adv in advantages" :key="adv.id">
        <h4>{{ adv.title }}</h4>
        <p>{{ adv.desc }}</p>
      </div>
    </div>
  </div>
</section>

<!-- 5. 应用场景 (白色背景) -->
<section class="lib-scenarios">
  <div class="container">
    <div class="section-title">
      <h2>应用场景</h2>
    </div>
    <div class="scenarios-grid">
      <div class="scenario-card" v-for="scene in scenarios" :key="scene.id">
        <div class="scenario-img-box">
          <!-- 引入场景图片 -->
          <img :src="scene.img" :alt="scene.title" class="scene-img">
        </div>
        <div class="scenario-info">
          <h4>{{ scene.title }}</h4>
          <p>{{ scene.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回产品矩阵</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'AILibrarySearch',
  components: {  AppFooter },
  data() {
    return {
      features: [
  {
    id: 1,
    title: '实时语音交互',
    desc: '支持自然语音理解与对话，毫秒级响应，沟通更流畅。'
  },
  {
    id: 2,
    title: '校园智能问答',
    desc: '基于知识库与大模型能力，精准解答各类问题。'
  },
  {
    id: 3,
    title: '多模态交互',
    desc: '语音、文字多模态交互，满足不同场景需求。'
  },
  {
    id: 4,
    title: '软硬件一体化',
    desc: '智能终端设备+系统平台深度融合，远程运维，安全文档。' 
    // 注：图片中文字较模糊，看起来像“字眼”，此处根据语境修正为“智能”或保留原意，请根据实际情况调整
  }
],
     terminalFeatures: [
  { text: '27英寸触控大屏，高清显示' },
  { text: '阵列麦克风+高清摄像头，语音识别更精准' },
  { text: '工业级设计，稳定耐用' },
  { text: '支持壁挂/落地多种安装方式' },
  { text: '支持系统远程升级与设备管理' }
],
    advantages: [
  { 
    id: 1, 
    title: 'AI技术领先', 
    desc: '融合大模型与知识图谱，持续提升理解与服务能力' 
  },
  { 
    id: 2, 
    title: '数据安全可靠', 
    desc: '本地化部署与多重安全机制，保障校园数据安全' 
  },
  { 
    id: 3, 
    title: '快速接入落地', 
    desc: '标准化接口与灵活部署方案，快速上线，按需扩展' 
  },
  { 
    id: 4, 
    title: '专业服务支持', 
    desc: '7×24小时运维支持，持续优化使用体验' 
  }
],
    scenarios: [
      { 
        id: 1, 
        title: '教学楼/图书馆', 
        desc: '资源检索、知识问答、知识科普',
        img: require('@/assets/images/scene-school.png') // 替换为真实路径
      },
      { 
        id: 2, 
        title: '学生社区/宿舍区', 
        desc: '生活服务、报修投诉、通知公共',
        img: require('@/assets/images/scene-university.png')
      },
      { 
        id: 3, 
        title: '行政服务大厅', 
        desc: '办事咨询、流程引导、政策解读',
        img: require('@/assets/images/scene-public.png')
      },
      { 
        id: 4, 
        title: '校园门口/广场', 
        desc: '迎新导览、校园介绍、活动咨询',
        img: require('@/assets/images/scene-enterprise.png')
      }]
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    contactUs() {
      alert('联系电话：020-82038386')
    }
  }
}
</script>

<style scoped>
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* 1. Banner (深色背景图) */
.lib-banner {
  position: relative;
  /* 引入背景图片 - 包含左侧走廊和右侧设备 */
  background-image: url('../assets/images/class-card-banner-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  padding: 120px 0;
  min-height: 600px;
  display: flex;
  align-items: center;
}

/* 渐变遮罩：左侧深色保护文字，右侧透明显示设备 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 从左到右：深色渐变到透明 */
  /* background: linear-gradient(to right, 
    rgba(15, 23, 42, 0.95) 0%, 
    rgba(15, 23, 42, 0.9) 45%, 
    rgba(15, 23, 42, 0.4) 75%,
    transparent 100%); */
}

.lib-banner .container { 
  display: flex; 
  align-items: center; 
  justify-content: flex-start; /* 内容靠左 */
  width: 100%;
}

.banner-content { 
  flex: 1;
  max-width: 600px; /* 限制文字区域宽度 */
}

.banner-content h1 { 
  font-size: 56px; 
  line-height: 1.2; 
  margin-bottom: 20px; 
  font-weight: bold;
}

.subtitle { 
  font-size: 22px; 
  color: rgba(255, 255, 255, 0.9); 
  margin-bottom: 40px; 
  font-weight: 500;
}

.btn-primary { 
  background: #10b1f2; 
  color: #fff; 
  border: none; 
  padding: 14px 32px;
  border-radius: 24px; 
  font-size: 16px; 
  cursor: pointer; 
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.btn-primary:hover { 
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
}

.divider {
  opacity: 0.6;
  margin: 0 4px;
}

/* 响应式 */
@media (max-width: 992px) {
  .banner-content h1 {
    font-size: 40px;
  }
  
  .subtitle {
    font-size: 18px;
  }
  
  .banner-overlay {
    background: rgba(15, 23, 42, 0.85); /* 手机端全遮罩 */
  }
}

@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 32px;
  }
  
  .subtitle {
    font-size: 16px;
  }
}
/* 2. Features (白色) */
.lib-features { 
  padding: 80px 0; 
  background: #f8fafc; /* 改为浅蓝灰色背景 */
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title { 
  text-align: center; 
  margin-bottom: 50px; 
}

.section-title h2 { 
  font-size: 32px; /* 标题稍微加大 */
  color: #0f172a; /* 深黑色 */
  margin-bottom: 12px;
  font-weight: bold;
  margin-top: 0;
}

.section-title .subtitle {
  font-size: 16px;
  color: #475569; /* 副标题灰色 */
  font-weight: 600;
  margin: 0;
}

.features-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; 
}

.feature-card {
  background: #fff; 
  padding: 40px 20px 30px; /* 调整内边距 */
  border-radius: 16px; /* 圆角加大 */
  text-align: center; 
  border: 1px solid #f1f5f9; /* 极淡的边框 */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02); /* 轻微阴影 */
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-card:hover { 
  transform: translateY(-5px); 
  box-shadow: 0 10px 30px rgba(0,0,0,0.05); 
}

.feature-card h4 { 
  margin-top: 0;
  margin-bottom: 16px; 
  color: #1e293b; 
  font-size: 18px; /* 标题加大 */
  font-weight: bold;
  min-height: 24px;
}

.feature-card p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.6;
  margin: 0 0 24px 0; /* 底部留白给图标 */
  flex-grow: 1; /* 让内容撑开，把图标推到底部 */
}

.icon-box {
  width: 56px; 
  height: 56px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  margin-top: auto; /* 确保图标在最下方 */
}

.feature-icon {
  width: 48px; /* 图标稍微加大 */
  height: 48px;
  object-fit: contain;
  /* 如果原图是黑色的，可以用以下滤镜变蓝，如果是蓝色图片则不需要 */
  /* filter: invert(43%) sepia(93%) saturate(1352%) hue-rotate(176deg) brightness(90%) contrast(95%); */
}
/* 3 */
.lib-terminal { 
  padding: 80px 0; 
  background: #fff; /* 图片背景看起来是白色的，或者浅灰，根据整体风格调整 */
}

/* .section-title { 
  text-align: center; 
  margin-bottom: 60px; 
}

.section-title h2 { 
  font-size: 32px; 
  color: #0f172a; 
  margin-bottom: 12px;
  font-weight: bold;
  margin-top: 0;
}

.section-title .subtitle {
  font-size: 16px;
  color: #475569;
  margin: 0;
} */

.terminal-layout { 
  display: flex; 
  align-items: center; /* 改为垂直居中 */
  justify-content: space-between;
  gap: 60px; 
  max-width: 1400px; /* 加宽容器 */
  margin: 0 auto;
  padding: 0 20px;
}

.terminal-features { 
  flex: 1; 
  max-width: 500px;
}

.tf-item {
  display: flex; 
  align-items: center; /* 图标和文字垂直居中 */
  gap: 16px; 
  margin-bottom: 30px;
}

.check-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  /* 如果图标不是蓝色的，可以用 filter 调整，或者换图 */
}

.check-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.tf-content {
  flex: 1;
}

.feature-text {
  display: block;
  color: #1e293b; /* 深色文字 */
  font-size: 18px; /* 字体加大 */
  font-weight: 600; /* 加粗 */
  line-height: 1.4;
}

/* 去掉原来的 strong 和 p 样式，因为结构变了 */
.tf-item strong, .tf-item p {
  display: none; 
}

.terminal-device { 
  flex: 1; 
  display: flex; 
  justify-content: center;
  align-items: center;
}

.image-wrapper {
  position: relative;
  /* 去掉了虚线框和白色背景，让设备图更自然 */
  /* 如果设备图需要白底衬托，可以保留 background: #fff; box-shadow: ... */
  border-radius: 12px;
  overflow: hidden;
}

.device-img {
  max-width: 100%;
  height: auto;
  display: block;
  /* 如果原图是直立的，想要图片中的斜视效果，可以加 transform */
  /* transform: perspective(1000px) rotateY(-15deg) rotateX(5deg); */
  /* box-shadow: 0 20px 40px rgba(0,0,0,0.1); */
}

/* 响应式 */
@media (max-width: 992px) {
  .terminal-layout {
    flex-direction: column;
    gap: 50px;
    text-align: center;
  }
  
  .tf-item {
    justify-content: flex-start; /* 保持左对齐，或者改为 center */
    text-align: left;
  }
}
/* 4. Advantages (极淡蓝灰背景) */
.lib-advantages { 
  padding: 80px 0; 
  background: #f8fafc; /* 极淡的背景色 */
}

/* .section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 28px;
  color: #0f172a;
  margin: 0 0 10px 0;
  font-weight: bold;
}

.section-title .subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
} */

.adv-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); /* 修改为4列 */
  gap: 40px; /* 增加间距 */
}

.adv-item {
  text-align: center;
  padding: 20px 10px;
  /* 可选：添加轻微的卡片效果 */
  /* background: #fff; */
  /* border-radius: 8px; */
}

.adv-item h4 { 
  margin-bottom: 12px; 
  color: #1e293b; 
  font-size: 16px; 
  font-weight: 600; /* 加粗 */
}

.adv-item p { 
  font-size: 13px; 
  color: #94a3b8; /* 描述文字颜色更淡一些 */
  line-height: 1.6; 
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .adv-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .adv-grid {
    grid-template-columns: 1fr;
  }
}

/* 5. Scenarios (白色背景) */
.lib-scenarios { 
  padding: 80px 0; 
  background: #fff; 
}

.scenarios-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; 
}

.scenario-card {
  display: flex;
  flex-direction: column;
  gap: 15px; /* 图片和文字块的间距 */
}

/* 图片区域 */
.scenario-img-box {
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f5f9;
}

.scene-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 文字信息区域 (浅蓝色背景) */
.scenario-info {
  background: #f0f7ff; /* 浅蓝色背景 */
  padding: 20px 15px;
  border-radius: 12px;
  text-align: center;
}

.scenario-info h4 { 
  margin-bottom: 8px; 
  color: #1e293b; 
  font-size: 16px; 
  font-weight: bold;
}

.scenario-info p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.5; 
  margin: 0;
}

/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style>